<template>
  <div class="HomePageStyle">
    <top-component></top-component>
    <div class="container">
        <div>
            <el-carousel height="647px" :interval="3000">
                <el-carousel-item>
                    <!-- <router-link to="/sehb/1">-->
                        <img class="banner_i" src="../../assets/qmyd/banner.jpg" height="647px" width="1920px">
                    <!-- </router-link> -->
                </el-carousel-item>
                <!-- <el-carousel-item>      
                    <router-link to="/sehb/2">
                        <img class="banner_i" src="../../assets/qmyd/banner02.jpeg" height="647px" width="1920px">
                    </router-link>
                </el-carousel-item>
                <el-carousel-item>
                    <router-link to="/sehb/3">
                        <img class="banner_i" src="../../assets/qmyd/banner03.jpeg" height="647px" width="1920px">
                    </router-link>
                </el-carousel-item>
                <el-carousel-item>
                    <img class="banner_i" src="../../assets/qmyd/banner04.jpeg" height="647px" width="1920px">
                </el-carousel-item> -->
            </el-carousel>
        </div>
        <!-- <img class="banner_i" src="../../assets/qmyd/banner.jpg" height="560px" width="1920px" /> -->
        <div class="activeShow" style="background-color:#fafafa;"><!-- -->
            <!-- <h2 class="">活动展示</h2> -->
            <div class="content_show">
                <div class="show_text">
                    <h2>百社</h2>
                    <p>集百家之所长，融百家之所思，扬百家之所名。</p>
                </div>
                <div class="showTitle">优秀作品选集</div>
                <div class="video_box" style="width:1280px;margin:0 auto;">  
                    <video style="width: 420px; height:280px;" controls="controls" loop="loop">
                        <!-- 您的浏览器不支持 video 标签。 -->
                        <source src="https://outin-b41c3368774f11eabe3000163e06123c.oss-cn-shanghai.aliyuncs.com/27f12de075524188a6dade5e0545686e/437a43d0e63d4ccaa0dbc3986a52b1d5-9ad764b9efdd37ea0eeb719347eb16c9-sd.mp4" type="video/mp4" />
                    </video>  
                    <video style="width: 425px; height: 280px;" controls="controls" loop="loop">
                        <!-- 您的浏览器不支持 video 标签。 -->
                        <source src="https://outin-b41c3368774f11eabe3000163e06123c.oss-cn-shanghai.aliyuncs.com/39b1a00159d6411da01bf3b55f041dc8/cb91809cf1fe4b0fa323919b23c7fb82-f046cbeb644a4c6a32e6b47d6e454870-sd.mp4" type="video/mp4" />
                    </video>  
                    <video style="width: 425px; height: 280px;" controls="controls" loop="loop">
                        <!-- 您的浏览器不支持 video 标签。 -->
                        <source src="https://outin-b41c3368774f11eabe3000163e06123c.oss-cn-shanghai.aliyuncs.com/c98ccf0f0d2a4f5eb8dbccb05bac2efc/3dd0616c32e34cc6b84e240f53c68e04-717db67d639d083525c6510e5c33a365-sd.mp4" type="video/mp4" />
                    </video> 
                </div>
            </div>
        </div>
        <div class="activeShow" style="background-color:#fafafa;"><!-- background-color:#89d090;color:#fff; -->
            <div class="content_show">
                <div class="show_text">
                    <h2>千馆</h2>
                    <p>汇千家之所想，解千家之所困，急千家之所需。</p>
                </div>
                <div class="showTitle">优秀作品选集</div>
                <div class="video_box" style="width:1280px;margin:0 auto;">  
                    <video style="width: 420px; height:280px;" controls="controls" loop="loop">
                        <!-- 您的浏览器不支持 video 标签。 -->
                        <source src="https://outin-b41c3368774f11eabe3000163e06123c.oss-cn-shanghai.aliyuncs.com/5f6c41fc3e5345e08dfe1b14dd227f76/b6c070325abb4a3fa6d2eca75c5f2721-060018c667e3d8cdbc0233000d771578-sd.mp4" type="video/mp4" />
                    </video>  
                    <video style="width: 420px; height: 280px;" controls="controls" loop="loop">
                        <!-- 您的浏览器不支持 video 标签。 -->
                        <source src="https://outin-b41c3368774f11eabe3000163e06123c.oss-cn-shanghai.aliyuncs.com/36fcaa8f8e5343beb3bc591a99ac7538/25887bb825124008aef28aec5287826b-e7b2b400fa49aa4231484ff448769428-sd.mp4" type="video/mp4" />
                    </video>  
                    <video style="width: 420px; height: 280px;" controls="controls" loop="loop">
                        <!-- 您的浏览器不支持 video 标签。 -->
                        <source src="https://outin-b41c3368774f11eabe3000163e06123c.oss-cn-shanghai.aliyuncs.com/d3a49af9c1984513847246c68bc83041/83561531fde54b3caf34654d15383059-54d905e7660f955d5d0194af2684cbab-sd.mp4" type="video/mp4" />
                    </video> 
                </div>
            </div>
        </div>
        <div class="activeShow" style="background-color:#fafafa;"><!-- -->
            <!-- <h2 class="">活动展示</h2> -->
            <div class="content_show">
                <div class="show_text">
                    <h2>万人读</h2>
                    <p>合万千人之所才，揽万千人之所思，聚万千人之所智。</p>
                    <!-- <p>阐释三新人对阅读的理解向社会展示三新人践行“大步迈向书香社会”这一使命的勇气和决心。</p> -->
                </div>
                <div class="showTitle">优秀作品选集</div>
                <div class="video_box" style="width:1280px;margin:0 auto;">  
                    <video style="width: 420px; height: 250px;" controls="controls" loop="loop">
                        <!-- 您的浏览器不支持 video 标签。 -->
                        <source src="https://outin-b41c3368774f11eabe3000163e06123c.oss-cn-shanghai.aliyuncs.com/6c5cb7e4bbe6413da0247de059df54e7/a98b393220c94d9a8e8091028bacccfb-7f2bbda8475a268c547ec7ec44a39b0f-sd.mp4" type="video/mp4" />
                    </video>   
                    <video style="width: 420px; height: 250px;" controls="controls" loop="loop">
                        <!-- 您的浏览器不支持 video 标签。 -->
                        <source src="https://outin-b41c3368774f11eabe3000163e06123c.oss-cn-shanghai.aliyuncs.com/da6d2ca67bd4435ba9329325ec369c40/c697ac7037fd43779cb843d8c7ff8903-f02f6d14f785930cc5c6031edf58a55c-sd.mp4" type="video/mp4" />
                    </video>   
                    <video style="width: 420px; height: 250px;" controls="controls" loop="loop">
                        <!-- 您的浏览器不支持 video 标签。 -->
                        <source src="https://outin-b41c3368774f11eabe3000163e06123c.oss-cn-shanghai.aliyuncs.com/22b92f1e83f1418eb96d699dbf320607/70cf18ce520b46e1b3431cece3804e7f-19989632c8d99847516f770031cdafd9-sd.mp4" type="video/mp4" />
                    </video>   
                    <video style="width: 420px; height: 250px;" controls="controls" loop="loop">
                        <!-- 您的浏览器不支持 video 标签。 -->
                        <source src="https://outin-b41c3368774f11eabe3000163e06123c.oss-cn-shanghai.aliyuncs.com/0b7b6c80fb9546848d46ea6cc97beeb4/4bf51f461e0547d7ac70788377cdc563-35e1a89309d5234949106dfe027fc162-sd.mp4" type="video/mp4" />
                    </video>   
                    <video style="width: 420px; height: 250px;" controls="controls" loop="loop">
                        <!-- 您的浏览器不支持 video 标签。 -->
                        <source src="https://outin-b41c3368774f11eabe3000163e06123c.oss-cn-shanghai.aliyuncs.com/4f65300782f7480da3dc85b0147dc577/8db169af49174c4daff6b447b0230909-8cbedbdb6e3ec8345cd753cb3865813a-sd.mp4" type="video/mp4" />
                    </video>   
                    <video style="width: 420px; height: 250px;" controls="controls" loop="loop">
                        <!-- 您的浏览器不支持 video 标签。 -->
                        <source src="https://outin-b41c3368774f11eabe3000163e06123c.oss-cn-shanghai.aliyuncs.com/1b1516e030e64f578b648fd0a2f571cc/e42f032eca84425699a06cf2f472cbb5-08ac02adc04944b39451457b56b14c31-sd.mp4" type="video/mp4" />
                    </video>   
                    <video style="width: 420px; height: 250px;" controls="controls" loop="loop">
                        <!-- 您的浏览器不支持 video 标签。 -->
                        <source src="https://outin-b41c3368774f11eabe3000163e06123c.oss-cn-shanghai.aliyuncs.com/edaa276763534bc99fffe130fd1340b0/b7c3520e14af42f3b2c2cda9277adb75-ff395d485bdc69002131a3a6d4a84a3e-sd.mp4" type="video/mp4" />
                    </video>  
                    <video style="width: 420px; height: 250px;" controls="controls" loop="loop">
                        <!-- 您的浏览器不支持 video 标签。 -->
                        <source src="https://outin-b41c3368774f11eabe3000163e06123c.oss-cn-shanghai.aliyuncs.com/06acddb8a18d44f18939fb8777b3b5f1/8f774fbc3a984d08b5f30a2ff127c308-fe44246a3481f9aea99e6fd1d9913875-sd.mp4" type="video/mp4" />
                    </video>   
                    <video style="width: 420px; height: 250px;" controls="controls" loop="loop">
                        <!-- 您的浏览器不支持 video 标签。 -->
                        <source src="https://outin-b41c3368774f11eabe3000163e06123c.oss-cn-shanghai.aliyuncs.com/f4c7408618e4415d8667922741af549a/c85b06d27b7846fdbba27126ec6f7582-d937af0698b6e7b079ef7894dc0872cf-sd.mp4" type="video/mp4" />
                    </video>   
                    <video style="width: 420px; height: 250px;" controls="controls" loop="loop">
                        <!-- 您的浏览器不支持 video 标签。 -->
                        <source src="https://outin-b41c3368774f11eabe3000163e06123c.oss-cn-shanghai.aliyuncs.com/0dddfef6aeb741adad7ee18122b82106/f10560726c6b481589dc1b2302650a0c-3107d65219cd26beab9fbcc55513ff02-sd.mp4" type="video/mp4" />
                    </video>    
                    <video style="width: 420px; height: 250px;" controls="controls" loop="loop">
                        <!-- 您的浏览器不支持 video 标签。 -->
                        <source src="https://outin-b41c3368774f11eabe3000163e06123c.oss-cn-shanghai.aliyuncs.com/ce76c3c2724f41e8b48d8c37ec46676f/cabedb45c95641fd9e1fc31ae2f39a1b-60cdbcfaaeb1b00c7b4dc329e597a7f4-sd.mp4" type="video/mp4" />
                    </video>   
                    <video style="width: 420px; height: 250px;" controls="controls" loop="loop">
                        <!-- 您的浏览器不支持 video 标签。 -->
                        <source src="https://outin-b41c3368774f11eabe3000163e06123c.oss-cn-shanghai.aliyuncs.com/6c49ba3fe6644d1d9db8d0e9372c8dcf/2e7e322df18b405689ec7531e1dcef68-175a1334ec6f47d494f39f6bd8541abd-sd.mp4" type="video/mp4" />
                    </video>   
                </div>
            </div>
        </div>
        <!-- <div class="activeShow" style="background-color:#ea7171;color:#fff;">
            <div class="content_show fclear">
                <div class="video_box fl">                    
                    <video style="width: 100%; height: 100%;" src ="https://outin-b41c3368774f11eabe3000163e06123c.oss-cn-shanghai.aliyuncs.com/sv/5d805406-1714aec9846/5d805406-1714aec9846.mp4" muted loop="loop" controls="controls">
                        您的浏览器不支持 video 标签。
                    </video>
                </div>
                <div class="show_text fr">
                    <h3>我的书屋，我的梦</h3>
                    <p>开启家庭阅读是一座城市的幸运和希望</p>
                </div>
            </div>
        </div> -->
    </div>
    <bottom-component></bottom-component>
  </div>
</template>
<script>
  import BottomComponent from '../Components/BottomComponent.vue'
  import TopComponent from '../Components/TopComponent.vue'
  import Cookies from 'js-cookie'

    export default {
        data(){
            return{

            }
        },
        components:{
            BottomComponent,
            TopComponent
        },
        mounted(){

        },
        methods:{
            
       // 特色专区 （图采会专栏、类目）
            TESEtuijianTo(activityTag, name) {
                if(Cookies.get('token')){
                    let params = {
                        gid:'0',
                        TitleName: name,
                        publicType: '', // 大众分类
                        cnIbraryType: '', // 中图分类
                        subjectId: '', // 学科类别
                        activityTag: activityTag, // 1精品大码洋/2畅销书/3医学/4抗疫图书/5少儿专区/6推荐书单/7工具书
                        // activityTag: '', // 经典珍藏/重磅推荐/乐活趣览
                        goodsType: 1
                    };
                    this.$router.push({
                        name: 'LookPublishingPagesType',
                        query: {obj: JSON.stringify(params)}
                    })
                }else{
                    this.$router.push({ name: 'Login'});
                }
            }
        }
    }

</script>

<style scoped lang="scss">
    .bannerBox{
        cursor: pointer;
    }
    .activeShow{
        padding:80px 0px;
    }
    .fl{
        float: left;
    }
    .fr{
        float: right;
    }
    .fclear::after{
        content: "";
        height: 0;
        overflow: hidden;
        display: block;
        clear: both;
    }
    .content_show{
        width: 1180px;
        margin: 0px auto;
        text-align: center;
    }
    .video_box{
        // width: 780px;
        // height: 400px;
    }
    .video_box video{
        background-color: #000;
    }
    .show_text{
        // width:320px;
        // padding:60px 40px;
        h2{
            font-size:36px;
        }
        p{
            font-size: 24px;
            padding: 40px 0;
            color: #666;
        }   
    }
    .showTitle{
        display: inline-block;
        color: #fff;
        font-weight: bold;
        padding: 10px 25px;
        border-radius:999px;
        margin-bottom: 20px;
        background-color: #ffb334;
    }
</style>


// WEBPACK FOOTER //
// src/views/qmyd/index.vue